module.exports = __webpack_public_path__ + "static/media/Thunderstorm.c84d082e.jpg";